<template>
  <v-card-text class="pa-6">
    <div class="d-flex justify-space-between align-center mb-4">
      <h3 class="text-h6">
        <v-icon left color="primary">mdi-file-document-multiple</v-icon>
        ประวัติสัญญาจ้าง
      </h3>
      <v-btn color="primary" @click="$emit('add')">
        <v-icon left>mdi-plus</v-icon>
        เพิ่มสัญญา
      </v-btn>
    </div>

    <v-data-table
      :headers="headers"
      :items="contracts"
      :loading="loading"
      no-data-text="ไม่มีข้อมูลสัญญา"
      hide-default-footer
      :items-per-page="20"
      class="elevation-1"
    >
      <template v-slot:item.contract_start_date="{ item }">
        <v-chip small color="green" text-color="white">
          {{ formatDate(item.contract_start_date) }}
        </v-chip>
      </template>
      
      <template v-slot:item.contract_end_date="{ item }">
        <v-chip small color="red" text-color="white">
          {{ formatDate(item.contract_end_date) }}
        </v-chip>
      </template>
      
      <template v-slot:item.contract_file="{ item }">
        <v-btn
          v-if="item.contract_file"
          icon
          small
          color="primary"
          @click="$emit('view-file', item.contract_file, 'สัญญาจ้าง')"
        >
          <v-icon>mdi-file-pdf-box</v-icon>
        </v-btn>
        <span v-else class="grey--text">ไม่มีไฟล์</span>
      </template>
      
      <template v-slot:item.created_at="{ item }">
        <span class="text-caption grey--text">
          {{ formatDateTime(item.created_at) }}
        </span>
      </template>
      
      <template v-slot:item.actions="{ item }">
        <v-btn icon small color="orange" @click="$emit('edit', item)" class="mr-1">
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
        <v-btn icon small color="red" @click="$emit('delete', item)">
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </template>
    </v-data-table>
  </v-card-text>
</template>

<script>
export default {
  name: 'ContractHistory',
  
  props: {
    contracts: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  
  data() {
    return {
      headers: [
        { text: 'วันเริ่ม', value: 'contract_start_date', align: 'center', width: '120px' },
        { text: 'วันสิ้นสุด', value: 'contract_end_date', align: 'center', width: '120px' },
        { text: 'เลขที่คำสั่ง', value: 'contract_order', align: 'center' },
        { text: 'หมายเหตุ', value: 'contract_note' },
        { text: 'ไฟล์', value: 'contract_file', align: 'center', width: '80px', sortable: false },
        { text: 'วันที่บันทึก', value: 'created_at', align: 'center', width: '140px' },
        { text: 'จัดการ', value: 'actions', align: 'center', width: '100px', sortable: false }
      ]
    }
  },
  
  methods: {
    formatDate(dateString) {
      if (!dateString) return ''
      try {
        return new Date(dateString).toLocaleDateString('th-TH')
      } catch {
        return dateString
      }
    },
    
    formatDateTime(dateString) {
      if (!dateString) return ''
      try {
        return new Date(dateString).toLocaleString('th-TH')
      } catch {
        return dateString
      }
    }
  }
}
</script>